import { useRef } from 'react'

export const useOnce = (fn: () => void): void => {
  const called = useRef(false)

  if (!called.current && 'window' in globalThis) {
    called.current = true
    fn()
  }
}
